import { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import { courses as mockCourses } from '../mocks/courses';

const STORE_KEY = 'learnflow_courses_store';

function loadCourses() {
  try {
    const stored = localStorage.getItem(STORE_KEY);
    if (stored) return JSON.parse(stored);
  } catch { /* ignore */ }
  return mockCourses;
}



const CourseStoreContext = createContext(null);

export function CourseStoreProvider({ children }) {
  const [courses, setCourses] = useState(loadCourses);

  const addCourse = useCallback((course) => {
    setCourses(prev => {
      const updated = [...prev, course];
      localStorage.setItem(STORE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const updateCourse = useCallback((course) => {
    setCourses(prev => {
      const updated = prev.map(c => c.id === course.id ? course : c);
      localStorage.setItem(STORE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const deleteCourse = useCallback((courseId) => {
    setCourses(prev => {
      const updated = prev.filter(c => c.id !== courseId);
      localStorage.setItem(STORE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const getCourse = useCallback((id) => {
    return courses.find(c => c.id === id);
  }, [courses]);

  return (
    <CourseStoreContext.Provider value={{ courses, addCourse, updateCourse, deleteCourse, getCourse }}>
      {children}
    </CourseStoreContext.Provider>
  );
}

export function useCourseStore() {
  const ctx = useContext(CourseStoreContext);
  if (!ctx) throw new Error('useCourseStore must be inside CourseStoreProvider');
  return ctx;
}
